import { ElementRef, useEffect, useRef, useState } from 'react'

import { getPopupWrapperDom } from '@hhgtech/hhg-components'
import { AttachImageType } from 'components/molecules/editor/types'
import * as ReactDOM from 'react-dom'

import { InputCommentBar } from '..'
import { Comment, Post } from '../../interfaces/types'
// import { toggleNoScroll } from 'utils'
import { StyledFormWrapper, StyledNote, StyledPopupFrame } from './index.styled'

export type Props = {
  heading?: string
  note?: string
  isMobile?: boolean
  onClose?: () => void
  children: any
  value?: string
  imageFiles?: AttachImageType
  bannedWords?: string[]
  post?: Post
  btnLabel?: string
  headerTitle?: any
  onPostSuccess?: (c: Comment) => void
  show?: boolean
  isEdit?: boolean
  isReply?: boolean
  commentId?: string
}

export const ExpandPopup = ({
  heading,
  note,
  isMobile,
  onClose,
  bannedWords,
  value,
  imageFiles,
  post,
  btnLabel,
  headerTitle,
  onPostSuccess,
  isEdit,
  isReply,
  commentId,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const inputCommentRef = useRef<ElementRef<typeof InputCommentBar>>(null)

  const inputCommentProps = {
    btnLabel,
    ref: inputCommentRef,
    showFullEditor: true,
    value,
    post,
    imageFiles,
    bannedWords,
    headerTitle,
    onPostSuccess,
    isEdit,
    isReply,
    commentId,
  }

  // HANDLE etra action when OPEN AND CLOSE
  useEffect(() => {
    setTimeout(() => {
      inputCommentRef?.current?.focusEditor()
    }, 1000)
    // toggleNoScroll(true)
    setTimeout(() => {
      setIsOpen(true)
    }, 0)
    // return () => toggleNoScroll(false)
  }, [])

  return ReactDOM.createPortal(
    <StyledPopupFrame
      heading={heading}
      className="create-post-popup-frame"
      isOpen={isOpen}
      onClose={onClose}
      hasFullscreen={!isMobile}
    >
      <StyledFormWrapper>
        {note && (
          <StyledNote
            dangerouslySetInnerHTML={{
              __html: note,
            }}
          />
        )}
        <InputCommentBar {...inputCommentProps} />
      </StyledFormWrapper>
    </StyledPopupFrame>,
    getPopupWrapperDom(),
  )
}
